"use client";

import { parseAsInteger, useQueryState } from "nuqs";
import { useCallback } from "react";

import { ControlledPagination } from "@/components/ui/pagination";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  ariaLabel: string;
  previousLabel: string;
  nextLabel: string;
  getPageLabel: (page: number) => string;
  className?: string;
}

const pageParser = parseAsInteger.withDefault(1).withOptions({
  history: "replace",
});

export function Pagination({
  currentPage,
  totalPages,
  ariaLabel,
  previousLabel,
  nextLabel,
  getPageLabel,
  className,
}: PaginationProps) {
  const [, setPage] = useQueryState("page", pageParser);

  const go = useCallback(
    async (page: number) => {
      await setPage(page <= 1 ? null : page);
    },
    [setPage]
  );

  return (
    <ControlledPagination
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={go}
      ariaLabel={ariaLabel}
      previousLabel={previousLabel}
      nextLabel={nextLabel}
      getPageLabel={getPageLabel}
      variant="customer"
      className={className}
    />
  );
}
